import {
  Form,
  Input,
  ModalProps,
  FormProps,
  Modal,
  InputNumber,
  Row,
  Col,
  Select,
  useSelect,
  Divider,
  Spin,
  Button,
  Typography,
  notification,
} from '@pankod/refine-antd'
import type { NotificationPlacement } from 'antd/es/notification'
import { useGetIdentity, useTable } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import {
  IBloomLevel,
  ICompetency,
  IDifficultyLevel,
  IQuestion,
  IQuestionType,
  IReportTheme,
  IStrand,
  ISubject,
  ISubTheme,
  ITheme,
  ITNTaxonomy,
  ITopic,
} from 'interfaces'
import React from 'react'
import { useState } from 'react'
import { createUserHistory } from 'gql/mutations'

type UploadQuestionProps = {
  modalProps: ModalProps
  close: any // formProps: FormProps
  reloadUploadedData: any
}

export const UploadTopics: React.FC<UploadQuestionProps> = ({ modalProps, close, reloadUploadedData }) => {
  const { data: user } = useGetIdentity()
  const [form] = Form.useForm<IQuestion>()
  const [subjectFilter, setSubjectFilter] = useState<any[]>([])

  const [loading, setLoading] = useState(false)
  const [uploading, setUploading] = useState(false)
  const [fileName, setFile] = useState('')
  const { userRole } = useUserContext()
  // const [file, setFile] = useState<FileDetails>()
  const fileReader = new FileReader()
  const [array, setArray] = useState<object[]>([])
  const { selectProps: subjectSelectProps } = useSelect<ISubject>({
    resource: 'subjects',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  const { selectProps: subThemeSelectProps } = useSelect<ISubTheme>({
    resource: 'sub_themes',
    fetchSize: 1000,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    filters: subjectFilter,
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const { selectProps: reportThemeSelectProps } = useSelect<IReportTheme>({
    resource: 'report_themes',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    filters: subjectFilter,
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const {
    filters: themeFilters,
    setFilters: setThemeFilters,
    tableQueryResult: themeResult,
  } = useTable<ITheme>({
    resource: 'themes',
    metaData: { fields: ['id', 'name', 'subject_id'] },
  })

  const {
    filters: subThemeFilters,
    setFilters: setSubThemeFilters,
    tableQueryResult: subThemeResult,
  } = useTable<ISubTheme>({
    resource: 'sub_themes',
    metaData: { fields: ['id', 'name', 'theme_id'] },
  })

  const handleSubjectChange = (value: { value: any }) => {
    setSubjectFilter([])
    form?.setFieldsValue({
      sub_theme_id: '',
      topic_id: '',
      theme_id: '',
      report_theme_id: '',
    })
    // setReportThemeData([])

    let data: any = [
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ]
    setSubjectFilter(data)
  }
  const handleReportThemeChange = (value: { value: any }) => {
    themeFilters.pop()
    form?.setFieldsValue({
      sub_theme_id: '',
      topic_id: '',
      theme_id: '',
    })
    setThemeFilters([
      {
        field: 'report_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const handleThemeChange = (value: { value: any }) => {
    subThemeFilters.pop()
    form?.setFieldsValue({
      sub_theme_id: '',
      topic_id: '',
    })
    setSubThemeFilters([
      {
        field: 'theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }

  const handleOnChange = (e: any) => {
    console.log('first', e.target.files[0])
    //  setBackground('opacity-blur')
    setLoading(true)
    // setLoading(true)
    // setShowUpload(false)
    setFile(e.target.files[0]['name'])
    // increase(20)
    handleOnSubmit(e.target.files[0])
  }
  const handleOnSubmit = (fs: any) => {
    if (fs) {
      fileReader.onload = function (event: any) {
        const csvOutput = event.target.result
        setArray(csvOutput)
        setLoading(false)
        // uploadQuestions(csvOutput)
        // csvFileToArray(csvOutput)
        //  increase(50)
      }

      fileReader.readAsText(fs)
    }
  }
  // const uploadQuestions = async (data: any) => {
  //   // alert(2)
  //   let details: object[] = []

  //   details.push({ csv: data })
  //   fetch('http://localhost:3001/upload-questions', {
  //     method: 'POST', // *GET, POST, PUT, DELETE, etc.
  //     body: JSON.stringify(details),
  //     headers: { 'Content-Type': 'application/json', charset: 'utf-8' },
  //   })
  //     .then(response => response.json())
  //     .then(data => {
  //       // setEvaluationData(data)
  //       if (data.length > 0) {
  //         // data?.map((item: any) => {
  //         //   updateEvaluationDetails(item?.id, item?.total_score, item?.answers)
  //         // })
  //       }
  //       setLoading(false)
  //       // setBackground('opacity1')
  //       // openNotification('bottomRight')
  //     })
  // }
  const openNotification = (placement: NotificationPlacement, message: string) => {
    notification.success({
      message: `Notification`,
      description: message,
      placement,
    })
    reloadUploadedData()
  }
  const onFinish = (values: any) => {
    setUploading(true)
    let details: object[] = []

    details.push({ csv: array, formValues: values })
    fetch(`${process.env.REACT_APP_BACKEND_URL}/upload-topics`, {
      //    fetch(`http://localhost:3001/upload-topics`, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      body: JSON.stringify(details),
      headers: { 'Content-Type': 'application/json', charset: 'utf-8' },
    })
      .then(response => response.json())
      .then(data => {
        if (data?.statusMessage === 'Success') {
          openNotification('bottomRight', 'Upload Success')
          form?.resetFields()
          close()
          setLoading(false)
          setUploading(false)
          // reloadUploadedData()
          setFile('')
          createUserHistory('topics', 'imported_form', '', user?.id, userRole)
        } else {
          openNotification('bottomRight', data?.statusMessage)
          form?.resetFields()
          close()
          setLoading(false)
          setUploading(false)
          // reloadUploadedData
          setFile('')
        }
      })
  }
  const onInputClick = (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    const element = event.target as HTMLInputElement
    element.value = ''
  }
  return (
    <Modal
      {...modalProps}
      title="Upload Topics"
      width={700}
      footer={[
        <Spin spinning={uploading} tip="Wait...Uploading..." />,
        <Button
          key="back"
          onClick={() => {
            form?.resetFields()
            setLoading(false)
            setUploading(false)
            close()
          }}
        >
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={form.submit} disabled={uploading}>
          Upload
        </Button>,
      ]}
    >
      <Form form={form} size="large" layout="vertical" onFinish={onFinish}>
        <Row gutter={[16, 0]}>
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Subject" name="subject_id" rules={[{ required: true }]}>
              <Select {...subjectSelectProps} onChange={handleSubjectChange} allowClear />
            </Form.Item>
          </Col> */}
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Report Theme (TN_Term_Month)" name="report_theme_id" rules={[{ required: true }]}>
              <Select
                {...reportThemeSelectProps}
                disabled={form?.getFieldValue('subject_id') === undefined || form?.getFieldValue('subject_id') == null ? true : false}
                onChange={handleReportThemeChange}
                allowClear
              />
            </Form.Item>
          </Col> */}
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Theme (TN Chapter Name)" name="theme_id" rules={[{ required: true }]}>
              <Select
                onChange={handleThemeChange}
                showSearch
                allowClear
                disabled={form?.getFieldValue('report_theme_id') === undefined || form?.getFieldValue('report_theme_id') == null ? true : false}
              >
                {themeResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col> */}
          <Col xs={24} lg={24}>
            <Form.Item
              label="Sub-theme(CENTA ConceptID_CENTA Concept Name)"
              style={{ overflow: 'hidden', height: '100%' }}
              name="sub_theme_id"
              rules={[{ required: true }]}
            >
              <Select
                // onChange={handleSubThemeChange}
                allowClear
                {...subThemeSelectProps}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={24} lg={24}>
            <div className="upload-btn-wrapper1">
              <button className="btnshow">Upload a file</button>
              <input type="file" name="myfile" id={'csvFileInput'} accept={'.csv'} onChange={handleOnChange} onClick={onInputClick} />
            </div>
            <Typography.Text type="success">{fileName}</Typography.Text>
          </Col>
        </Row>
        <Spin spinning={loading} tip="Wait...Uploading..." />
        <Form.Item name="created_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>

        {/* <Form.Item name="created_by" initialValue={}>
          <Input type="hidden" />
        </Form.Item> */}
      </Form>
    </Modal>
  )
}
